import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
// Components
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CartDrawer } from './components/CartDrawer';
// Pages
import { Home } from './pages/Home';
import { Shop } from './pages/Shop';
import { ProductDetail } from './pages/ProductDetail';
import { Checkout } from './pages/Checkout';
import { OrderConfirmation } from './pages/OrderConfirmation';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { FAQ } from './pages/FAQ';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Account } from './pages/Account';
function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen flex flex-col bg-[#F7F8FA] font-sans text-gray-900" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">{children}</main>
      <Footer data-id="element-3" />
      <CartDrawer data-id="element-4" />
      <Toaster position="bottom-right" data-id="element-5" />
    </div>;
}
export function App() {
  return <AuthProvider data-id="element-6">
      <CartProvider data-id="element-7">
        <Router data-id="element-8">
          <Layout data-id="element-9">
            <Routes data-id="element-10">
              <Route path="/" element={<Home data-id="element-12" />} data-id="element-11" />
              <Route path="/shop" element={<Shop data-id="element-14" />} data-id="element-13" />
              <Route path="/shop/:category" element={<Shop data-id="element-16" />} data-id="element-15" />
              <Route path="/product/:slug" element={<ProductDetail data-id="element-18" />} data-id="element-17" />
              <Route path="/checkout" element={<Checkout data-id="element-20" />} data-id="element-19" />
              <Route path="/order-confirmation" element={<OrderConfirmation data-id="element-22" />} data-id="element-21" />
              <Route path="/about" element={<About data-id="element-24" />} data-id="element-23" />
              <Route path="/contact" element={<Contact data-id="element-26" />} data-id="element-25" />
              <Route path="/faq" element={<FAQ data-id="element-28" />} data-id="element-27" />
              <Route path="/login" element={<Login data-id="element-30" />} data-id="element-29" />
              <Route path="/register" element={<Register data-id="element-32" />} data-id="element-31" />
              <Route path="/account/*" element={<Account data-id="element-34" />} data-id="element-33" />
              <Route path="/cart" element={<Navigate to="/checkout" replace data-id="element-36" />} data-id="element-35" />
              <Route path="*" element={<Navigate to="/" replace data-id="element-38" />} data-id="element-37" />
            </Routes>
          </Layout>
        </Router>
      </CartProvider>
    </AuthProvider>;
}